import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import LocaleModel from 'coreClasses/locales/LocaleModel';
import {IEcommerceData} from '../../IGoogleTagManager';
import ECommerceEventModel from './EcommerceEventModel';
import ECommerceProductDetailsModel from './models/EcommerceProductDetailsModel';

/**
 * Represents ECommerceProductRemoveFromCartEventModel
 */
export default class ECommerceProductRemoveFromCartEventModel extends ECommerceEventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const currentLocale: LocaleModel = this.managerRepository.getLocalesMgr().getCurrentLocale();

		this.ecommerce = {
			currencyCode: currentLocale.getCurrencyCode(),
			remove: {
				products: [{...new ECommerceProductDetailsModel(managerRepository, data.productData)}]
			}
		};
	}
};
